import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601DateTime: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

/** The root query type for the internal (VP staff) schema */
export type Query = {
  __typename?: 'Query';
  /** Get a single account by id */
  account?: Maybe<Account>;
  /** Feature-flag rows across accounts (defaults and per-account overrides) for staff */
  accountFeatures?: Maybe<AccountFeatureConnection>;
  /** Get a filtered and sorted paginated list of accounts */
  accounts?: Maybe<AccountCollection>;
  /** Accounts for a given feature flag, each flagged with whether it holds it; narrowable to holders or non-holders, name-searchable, paginated */
  accountsByFeature: FeatureAccountCollection;
  /** Get a single application config by id */
  applicationConfiguration?: Maybe<AppConfig>;
  /** Paginated list of application configs (alphabetical by name) */
  applicationConfigurations?: Maybe<AppConfigCollection>;
  /** List of available event categories, with their subcategories */
  categories: Array<Category>;
  /** The authenticated VenuePilot staff user */
  currentUser?: Maybe<CurrentUser>;
  /** Get a single customer by ID, resolved without account scoping */
  customer?: Maybe<CustomerDetails>;
  /** Cross-account list of customers for staff */
  customers: CustomerConnection;
  /** Cross-account, paginated and sortable list of email deliveries for staff, with terminal failure detail per row */
  emailDeliveries: EmailDeliveryConnection;
  /** Grouped email-delivery rollup (counts + failure rate per group) over the same filters as emailDeliveries; the reusable native-report shape */
  emailDeliverySummary: EmailDeliverySummary;
  /** Feature-flag change history from the audit log, newest first, paginated; filterable to one account and/or one feature (VP staff) */
  featureFlagHistory: FeatureFlagHistoryEntryCollection;
  /** Every declared feature flag with its adoption: live-account count and whether new accounts receive it by default */
  featureInventory: Array<FeatureInventory>;
  /** The catalog of available feature flags */
  features: Array<FeatureFlag>;
  /** List of available fee structures */
  feeStructures?: Maybe<Array<FeeStructure>>;
  /** Get a single order by ID, resolved without account scoping */
  order?: Maybe<OrderDetails>;
  /** Cross-account list of orders for staff */
  orders: OrderConnection;
  /** Organization record for an explicitly named account */
  organizations?: Maybe<Array<Organization>>;
  /** True when the caller is VenuePilot staff; the SPA reads it to render staff navigation (mirrors the AppSchema admin.tools => EDIT signal). Never false: non-staff are rejected with 401 or a top-level UNAUTHORIZED error and data: null, so treat absence (not a false value) as not-staff. */
  staff: Scalars['Boolean']['output'];
  /** A single ticket layout by id */
  ticketLayout?: Maybe<TicketLayout>;
  /** List of ticket layouts */
  ticketLayouts?: Maybe<TicketLayoutConnection>;
  /** List of available event types */
  types: Array<Type>;
  /** Cross-account staff lookup of users by partial email/name or exact id. Unlike orders/customers, an unfiltered listing is allowed here (a user lookup is inherently global) but is always paginated, so it never dumps every user; each result carries the user's account memberships for support workflows. */
  users: UserConnection;
  /** Cross-account, paginated and sortable list of login sessions for staff, with the device metadata each client supplied. Never exposes the session token. */
  userSessions: UserSessionConnection;
  /** Webhook subscription change history from the audit log, newest first, paginated; includes deleted subscriptions and is filterable to one account and a time range (VP staff) */
  webhookSubscriptionHistory: WebhookSubscriptionHistoryEntryCollection;
  /** List of whitelabel configurations, ordered by domain */
  whitelabelConfigs?: Maybe<Array<WhitelabelConfig>>;
  /** Last stored onboarding status for one whitelabel config; null until checked (VP staff) */
  whitelabelOnboardingStatus?: Maybe<WhitelabelOnboardingStatus>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryAccountArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type for the internal (VP staff) schema */
export type QueryAccountFeaturesArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryAccountsArgs = {
  filter?: InputMaybe<AccountFilterArguments>;
  pagination?: InputMaybe<PaginationArgument>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryAccountsByFeatureArgs = {
  feature: Scalars['String']['input'];
  holding?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationArgument>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryApplicationConfigurationArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type for the internal (VP staff) schema */
export type QueryApplicationConfigurationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryCustomerArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type for the internal (VP staff) schema */
export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerSearchArguments>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryEmailDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EmailDeliveryFilterArguments>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryEmailDeliverySummaryArgs = {
  filter?: InputMaybe<EmailDeliveryFilterArguments>;
  groupBy: EmailDeliveryGroupByEnum;
};


/** The root query type for the internal (VP staff) schema */
export type QueryFeatureFlagHistoryArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationArgument>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryOrderArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type for the internal (VP staff) schema */
export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderSearchArguments>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryOrganizationsArgs = {
  accountId: Scalars['Int']['input'];
};


/** The root query type for the internal (VP staff) schema */
export type QueryTicketLayoutArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type for the internal (VP staff) schema */
export type QueryTicketLayoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserSearchArguments>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryUserSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserSessionFilterArguments>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryWebhookSubscriptionHistoryArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  pagination?: InputMaybe<PaginationArgument>;
};


/** The root query type for the internal (VP staff) schema */
export type QueryWhitelabelOnboardingStatusArgs = {
  id: Scalars['Int']['input'];
};

/** A VenuePilot account (staff administration view) */
export type Account = {
  __typename?: 'Account';
  /** Box office payment processor for the account */
  boxOfficeProcessor: BoxOfficeProcessorEnum;
  /** How long a cart holds inventory, in minutes */
  cartLockDuration?: Maybe<Scalars['Float']['output']>;
  /** Fee structure applied to the account */
  feeStructure: FeeStructure;
  /** Identifier of the fee structure applied to the account */
  feeStructureId: Scalars['Int']['output'];
  /** Unique identifier for the account */
  id: Scalars['Int']['output'];
  /** Current logo attachment of the account, or null */
  logo?: Maybe<Attachment>;
  /** Name of the account */
  name: Scalars['String']['output'];
  /** Whether the account has completed onboarding */
  onboarded?: Maybe<Scalars['Boolean']['output']>;
  /** Owner user of the account */
  owner?: Maybe<AccountOwner>;
  /** Max recoupable share (basis points) across all stacked advances; null applies the 60% default */
  recoupmentCeilingBps?: Maybe<Scalars['Int']['output']>;
  /** The oldest active Soundcheck loan for the account, or null (see soundcheckLoans for all) */
  soundcheckLoan?: Maybe<Loan>;
  /** Static limits for creating a Soundcheck loan, or null */
  soundcheckLoanLimits?: Maybe<SoundcheckLoanLimits>;
  /** Every Soundcheck loan for the account (recoupment history), newest first */
  soundcheckLoans: Array<Loan>;
  /** Stripe account id used for Soundcheck financing */
  soundcheckStripeAccountId?: Maybe<Scalars['String']['output']>;
  /** Max webhook subscriptions the account may hold; null applies the platform default */
  webhookSubscriptionLimit?: Maybe<Scalars['Int']['output']>;
  /** Identifier of the whitelabel config, or null */
  whitelabelConfigId?: Maybe<Scalars['Int']['output']>;
};

/** Box office payment processor for an account */
export enum BoxOfficeProcessorEnum {
  External = 'external',
  Stripe = 'stripe',
  Unsupported = 'unsupported'
}

/** Fee structure */
export type FeeStructure = {
  __typename?: 'FeeStructure';
  /** Unique identifier for the fee structure */
  id: Scalars['Int']['output'];
  /** Name of the fee structure */
  name: Scalars['String']['output'];
};

/** A stored file attachment (VP staff) */
export type Attachment = {
  __typename?: 'Attachment';
  /** Identifier of the account that owns the attachment */
  accountId: Scalars['Int']['output'];
  /** Checksum of the stored file */
  checksum: Scalars['String']['output'];
  /** Identifier of the attachment this one was derived from, if any */
  derivedFromId?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the attachment */
  id: Scalars['Int']['output'];
  /** MIME type of the stored file */
  mime: Scalars['String']['output'];
  /** Original file name of the attachment */
  name: Scalars['String']['output'];
  /** Size of the stored file in bytes */
  size: Scalars['Int']['output'];
  /** Upload status of the attachment */
  status?: Maybe<AttachmentStatusEnum>;
  /** URL the attachment can be fetched from */
  url?: Maybe<Scalars['String']['output']>;
};

export enum AttachmentStatusEnum {
  Pending = 'PENDING',
  Ready = 'READY',
  Uploading = 'UPLOADING'
}

/** Owner of an account (staff administration view) */
export type AccountOwner = {
  __typename?: 'AccountOwner';
  /** Email address of the account owner */
  email: Scalars['String']['output'];
  /** Unique identifier of the account owner (user id) */
  id: Scalars['Int']['output'];
  /** Name of the account owner */
  name?: Maybe<Scalars['String']['output']>;
};

/** A Soundcheck financing loan for an account */
export type Loan = {
  __typename?: 'Loan';
  /** When the loan was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique identifier for the loan */
  id: Scalars['Int']['output'];
  /** Payments recouped against the loan, newest first */
  loanPayments: Array<LoanPayment>;
  /** Type of the loan */
  loanType: Scalars['String']['output'];
  /** Original principal balance of the loan */
  originalPrincipalBalance: Scalars['Float']['output'];
  /** Outstanding balance of the loan */
  outstandingBalance: Scalars['Float']['output'];
  /**
   * Per-ticket fee percentage, or null
   * @deprecated Superseded by the recoupment structure fields.
   */
  perTicketFeePercentage?: Maybe<Scalars['Float']['output']>;
  /** Estimated repayment date from projected sales and recoupment terms; an estimate, not a promise. */
  projectedPayoffDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether recoupment applies to ticket face value */
  recoupIncludesFaceValue: Scalars['Boolean']['output'];
  /** Whether recoupment applies to the venue fee */
  recoupIncludesVenueFee: Scalars['Boolean']['output'];
  /** Flat recoupment amount, in cents */
  recoupmentFlatCents: Scalars['BigInt']['output'];
  /** How the flat amount and percentage are applied */
  recoupmentGrain: RecoupmentGrainEnum;
  /** Recoupment percentage in basis points, or null */
  recoupmentPercentageBps?: Maybe<Scalars['Int']['output']>;
  /** Stripe account the advance settles to, or null */
  settlementStripeAccountId?: Maybe<Scalars['String']['output']>;
  /** Current status of the loan */
  status: Scalars['String']['output'];
  /** When the loan was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A single payment recouped against a loan */
export type LoanPayment = {
  __typename?: 'LoanPayment';
  /** Amount recouped by this payment */
  amount: Scalars['Float']['output'];
  /** When the payment was recorded */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique identifier for the loan payment */
  id: Scalars['Int']['output'];
  /** Payment status (e.g. PENDING, COMPLETED) */
  status: Scalars['String']['output'];
};

/** How an advance applies its flat amount and percentage */
export enum RecoupmentGrainEnum {
  PerOrder = 'per_order',
  PerTicket = 'per_ticket'
}

/** Static limits for creating a Soundcheck loan */
export type SoundcheckLoanLimits = {
  __typename?: 'SoundcheckLoanLimits';
  /** Maximum per-ticket fee percentage */
  feePercentageMax: Scalars['Float']['output'];
  /** Minimum per-ticket fee percentage */
  feePercentageMin: Scalars['Float']['output'];
  /** Maximum flat recoupment amount, in cents */
  flatCentsMax: Scalars['BigInt']['output'];
  /** Minimum flat recoupment amount, in cents */
  flatCentsMin: Scalars['BigInt']['output'];
  /** Maximum loan amount */
  maxAmount: Scalars['Float']['output'];
};

/** The connection type for AccountFeature. */
export type AccountFeatureConnection = {
  __typename?: 'AccountFeatureConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountFeatureEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AccountFeature>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AccountFeatureEdge = {
  __typename?: 'AccountFeatureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountFeature>;
};

/** A feature-flag row: an enabled feature for a specific account, or a default when the account id is null (VP staff administration surface) */
export type AccountFeature = {
  __typename?: 'AccountFeature';
  /** Account the feature applies to, or null for the default */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Machine name of the enabled feature flag */
  feature: Scalars['String']['output'];
  /** Unique identifier for the account feature record */
  id: Scalars['Int']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Set of parameters for filtering accounts */
export type AccountFilterArguments = {
  /** Filter by account name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PaginationArgument = {
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderingArgument = {
  /** The direction of ordering, either 'asc' or 'desc'. */
  direction: Scalars['String']['input'];
  /** The field to order by. */
  field: Scalars['String']['input'];
};

/** AccountCollection type */
export type AccountCollection = {
  __typename?: 'AccountCollection';
  /** A collection of paginated AccountCollection */
  collection: Array<Account>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

/** FeatureAccountCollection type */
export type FeatureAccountCollection = {
  __typename?: 'FeatureAccountCollection';
  /** A collection of paginated FeatureAccountCollection */
  collection: Array<FeatureAccount>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** An account paired with whether it holds a given feature flag (VP staff surface) */
export type FeatureAccount = {
  __typename?: 'FeatureAccount';
  /** The account */
  account: Account;
  /** Whether the account currently holds the queried feature flag */
  holdsFeature: Scalars['Boolean']['output'];
};

/** An application config: the API-consumer credential registry (VP staff) */
export type AppConfig = {
  __typename?: 'AppConfig';
  /** Context the app config targets */
  appContext?: Maybe<AppConfigContextEnum>;
  /** Generated public identifier for the API consumer */
  applicationId?: Maybe<Scalars['String']['output']>;
  /** Whether requests must match the configured origin */
  enforceOrigin?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the app config */
  id: Scalars['Int']['output'];
  /** Absolute https URL the login email sends buyers to (customer applications). The login token is appended as a `token` query parameter, keeping any other parameters and any fragment and replacing a `token` already there. Required for customer applications. */
  loginUrl?: Maybe<Scalars['String']['output']>;
  /** Human-readable name of the app config */
  name?: Maybe<Scalars['String']['output']>;
  /** Allowed request origin for the API consumer */
  origin?: Maybe<Scalars['String']['output']>;
  /** Requests allowed per window for each API key (or, without one, each user or anonymous IP) on this app; null = unlimited */
  rateLimitMaxRequests?: Maybe<Scalars['Int']['output']>;
  /** Length of the rate-limit window in seconds (1 to 3600) */
  rateLimitPeriodSeconds: Scalars['Int']['output'];
  /** Base URL for the API consumer */
  urlBase?: Maybe<Scalars['String']['output']>;
};

/** The application context an app config targets */
export enum AppConfigContextEnum {
  App = 'APP',
  BoxOffice = 'BOX_OFFICE',
  Checkout = 'CHECKOUT',
  Customer = 'CUSTOMER',
  PublicApi = 'PUBLIC_API'
}

/** AppConfigCollection type */
export type AppConfigCollection = {
  __typename?: 'AppConfigCollection';
  /** A collection of paginated AppConfigCollection */
  collection: Array<AppConfig>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Category */
export type Category = {
  __typename?: 'Category';
  /** Unique identifier for the category */
  id: Scalars['String']['output'];
  /** Name of the category */
  name: Scalars['String']['output'];
  /** Subcategories belonging to this category */
  subcategories: Array<Subcategory>;
};

/** Subcategory */
export type Subcategory = {
  __typename?: 'Subcategory';
  /** Category identifier this subcategory belongs to */
  categoryId: Scalars['String']['output'];
  /** Unique identifier for the subcategory */
  id: Scalars['String']['output'];
  /** Name of the subcategory */
  name: Scalars['String']['output'];
};

/** The authenticated VenuePilot staff user */
export type CurrentUser = {
  __typename?: 'CurrentUser';
  /** Email address of the staff user */
  email: Scalars['String']['output'];
  /** Unique identifier for the staff user */
  id: Scalars['Int']['output'];
  /** Name of the staff user */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the staff user is a superadmin */
  superadmin: Scalars['Boolean']['output'];
};

/** Represents a customer with their orders across every account */
export type CustomerDetails = {
  __typename?: 'CustomerDetails';
  /** Accounts this customer has orders in, derived via the orders join (not the legacy customers.account_id). A cross-account customer lists every account they transact on, even when the list is filtered to one. */
  accounts: Array<AccountSummary>;
  /** Timestamp when the customer was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Email address of the customer */
  email?: Maybe<Scalars['String']['output']>;
  /** First name of the customer */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the customer */
  id: Scalars['Int']['output'];
  /** Last name of the customer */
  lastName?: Maybe<Scalars['String']['output']>;
  /** All orders this customer has placed, across every account (staff cross-account view) */
  orders: OrderConnection;
  /** Phone number of the customer */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};


/** Represents a customer with their orders across every account */
export type CustomerDetailsOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Minimal account summary identifying which account an order belongs to */
export type AccountSummary = {
  __typename?: 'AccountSummary';
  /** Unique identifier for the account */
  id: Scalars['Int']['output'];
  /** Name of the account */
  name: Scalars['String']['output'];
};

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

/** Represents an order in the system, basic details */
export type Order = {
  __typename?: 'Order';
  /** The account associated with the order */
  account: AccountSummary;
  /** Card brand used for the order (from cc_type); null for non-card payments */
  cardBrand?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency code of the order */
  currency: Scalars['String']['output'];
  /** The customer associated with the order */
  customer?: Maybe<Customer>;
  /** The event associated with the order */
  event?: Maybe<EventSummary>;
  /** Unique fingerprint of the order */
  fingerprint: Scalars['String']['output'];
  /** Unique identifier for the order */
  id: Scalars['Int']['output'];
  /** Last four digits of the credit card used for the order */
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  /** The source of the order */
  origin: OrderOriginEnum;
  /** Payment method used for the order */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** Computed refund status of the order (none/partial/full) */
  refundStatus: RefundStatusEnum;
  /** Number of tickets scanned */
  scannedCount: Scalars['Int']['output'];
  /** Current state of the order */
  state: Scalars['String']['output'];
  /** Total number of tickets purchased */
  ticketCount: Scalars['Int']['output'];
  /** Total amount of the order */
  total: Scalars['Float']['output'];
  /** Transaction ID associated with the order payment */
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Represents a customer in the system, basic details */
export type Customer = {
  __typename?: 'Customer';
  /** Accounts this customer has orders in, derived via the orders join (not the legacy customers.account_id). A cross-account customer lists every account they transact on, even when the list is filtered to one. */
  accounts: Array<AccountSummary>;
  /** Timestamp when the customer was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Email address of the customer */
  email?: Maybe<Scalars['String']['output']>;
  /** First name of the customer */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the customer */
  id: Scalars['Int']['output'];
  /** Last name of the customer */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone number of the customer */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Minimal event summary for staff order views */
export type EventSummary = {
  __typename?: 'EventSummary';
  /** Unique identifier for the event */
  id: Scalars['Int']['output'];
  /** Name of the event */
  name?: Maybe<Scalars['String']['output']>;
  /** Scheduled start time of the event (UTC) */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timezone of the event/venue location */
  timezone?: Maybe<Scalars['String']['output']>;
};

export enum OrderOriginEnum {
  Online = 'online',
  Register = 'register'
}

export enum RefundStatusEnum {
  Full = 'full',
  None = 'none',
  Partial = 'partial'
}

export type CustomerSearchArguments = {
  /** Restrict customers to those with orders on this account. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Read customers across every account (staff cross-account access). This is the explicit way to request an unscoped read; when true it takes precedence over accountId. When false and no accountId is given, the query is rejected rather than silently returning every account. */
  allAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter customers created after this date/time */
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Filter customers created before this date/time */
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** General search query matching first name, last name, or email */
  q?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Customer. */
export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Customer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Customer>;
};

/** Filtering options shared by the email-delivery list and summary queries */
export type EmailDeliveryFilterArguments = {
  /** Restrict deliveries to this account. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Read deliveries across every account (staff cross-account access). This is the explicit way to request an unscoped read; when true it takes precedence over accountId. When false and no accountId is given, the query is rejected rather than silently returning every account. */
  allAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to a single mail stream (exact match). */
  mailStream?: InputMaybe<Scalars['String']['input']>;
  /** Filter to a single recipient email domain (case-insensitive exact match). */
  recipientDomain?: InputMaybe<Scalars['String']['input']>;
  /** Only deliveries sent at or after this time (matched on created_at, the indexed send column). */
  sentAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Only deliveries sent at or before this time (matched on created_at, the indexed send column). */
  sentBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Filter deliveries by one or more delivery states. */
  state?: InputMaybe<Array<EmailDeliveryStateEnum>>;
};

/** Lifecycle state of an email delivery */
export enum EmailDeliveryStateEnum {
  /** Confirmed delivered by SendGrid */
  Delivered = 'delivered',
  /** A terminal failure event was received (bounce, dropped, blocked, spamreport) */
  Failed = 'failed',
  /** Created but not yet handed to SendGrid */
  Pending = 'pending',
  /** Handed to SendGrid, awaiting a delivery or failure event */
  Sent = 'sent'
}

/** The connection type for EmailDelivery. */
export type EmailDeliveryConnection = {
  __typename?: 'EmailDeliveryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmailDeliveryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EmailDelivery>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EmailDeliveryEdge = {
  __typename?: 'EmailDeliveryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EmailDelivery>;
};

/** A single staff-visible email delivery, with terminal failure detail */
export type EmailDelivery = {
  __typename?: 'EmailDelivery';
  /** The account the email was sent on behalf of, if attributed */
  account?: Maybe<AccountSummary>;
  /** When the send was recorded */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When delivery was confirmed, if delivered */
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the email delivery */
  id: Scalars['Int']['output'];
  /** The mail stream (SendGrid category) the email was sent on */
  mailStream?: Maybe<Scalars['String']['output']>;
  /** The recipient email domain, lowercased */
  recipientDomain?: Maybe<Scalars['String']['output']>;
  /** When the email was handed to SendGrid, if sent */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current delivery state */
  state: EmailDeliveryStateEnum;
  /** Subject line of the email */
  subject: Scalars['String']['output'];
  /** Reason attached to the terminal SendGrid event (e.g. a bounce reason) */
  terminalEventReason?: Maybe<Scalars['String']['output']>;
  /** Type of the terminal SendGrid event (e.g. delivered, bounce) */
  terminalEventType?: Maybe<Scalars['String']['output']>;
  /** Recipient email address */
  to: Scalars['String']['output'];
};

/** The dimension to group the email-delivery summary by */
export enum EmailDeliveryGroupByEnum {
  /** Group by the sending account */
  Account = 'ACCOUNT',
  /** Group by the mail stream (SendGrid category) */
  MailStream = 'MAIL_STREAM',
  /** Group by the recipient email domain */
  RecipientDomain = 'RECIPIENT_DOMAIN'
}

/** A grouped email-delivery report. This is the reusable native-report shape — a list of { key, measures } groups plus a grand total — named generically so future native reports reuse the same envelope rather than an email-specific one. */
export type EmailDeliverySummary = {
  __typename?: 'EmailDeliverySummary';
  /** One entry per group, ordered by volume (largest first) */
  groups: Array<EmailDeliverySummaryGroup>;
  /** Grand total of deliveries across all groups (the true total, never capped) */
  total: Scalars['Int']['output'];
};

/** One row of the summary: a group key and its measures */
export type EmailDeliverySummaryGroup = {
  __typename?: 'EmailDeliverySummaryGroup';
  /** The group value: recipient domain, account id, or mail stream; null if that column is null */
  key?: Maybe<Scalars['String']['output']>;
  /** The measures for this group */
  measures: EmailDeliveryMeasures;
};

/** The measures for one summary group: counts plus the derived failure rate */
export type EmailDeliveryMeasures = {
  __typename?: 'EmailDeliveryMeasures';
  /** Number of deliveries confirmed delivered */
  delivered: Scalars['Int']['output'];
  /** Number of deliveries that failed (bounce, dropped, blocked, spamreport) */
  failed: Scalars['Int']['output'];
  /** failed / sent for this group (0.0 when sent is 0) */
  failureRate: Scalars['Float']['output'];
  /** Total deliveries in this group (every attempted send); the failureRate denominator */
  sent: Scalars['Int']['output'];
};

/** FeatureFlagHistoryEntryCollection type */
export type FeatureFlagHistoryEntryCollection = {
  __typename?: 'FeatureFlagHistoryEntryCollection';
  /** A collection of paginated FeatureFlagHistoryEntryCollection */
  collection: Array<FeatureFlagHistoryEntry>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** A single feature-flag change from the audit log (VP staff surface) */
export type FeatureFlagHistoryEntry = {
  __typename?: 'FeatureFlagHistoryEntry';
  /** Account the entry is recorded against; the master account for platform-default changes (see defaultScope) */
  accountId: Scalars['Int']['output'];
  /** Name of the account the entry is recorded against; null when that account no longer exists. On a defaultScope entry this is the master account -- ignore it when defaultScope is true */
  accountName?: Maybe<Scalars['String']['output']>;
  /** Who made the change; null when no actor was recorded (system change) or the actor's user record has since been removed */
  actor?: Maybe<FeatureFlagHistoryActor>;
  /** Shared across every entry from one apply-to-all bulk action; null for a single-account change */
  batchId?: Maybe<Scalars['String']['output']>;
  /** When the change was recorded */
  changedAt: Scalars['ISO8601DateTime']['output'];
  /** True when this changed the new-account platform default (recorded against the master account), not this account */
  defaultScope: Scalars['Boolean']['output'];
  /** Whether the feature was enabled (true) or disabled (false) */
  enabled: Scalars['Boolean']['output'];
  /** Machine name of the feature flag that changed */
  feature: Scalars['String']['output'];
  /** Unique identifier for the audit log entry */
  id: Scalars['Int']['output'];
};

/** The user who made a feature-flag change -- VP staff, or an account admin acting on their own account */
export type FeatureFlagHistoryActor = {
  __typename?: 'FeatureFlagHistoryActor';
  /** Email address of the user who made the change */
  email: Scalars['String']['output'];
  /** Unique identifier for the user who made the change */
  id: Scalars['Int']['output'];
  /** Name of the user who made the change */
  name?: Maybe<Scalars['String']['output']>;
};

/** A declared feature flag with its adoption across the platform (VP staff surface) */
export type FeatureInventory = {
  __typename?: 'FeatureInventory';
  /** Number of live accounts that hold the feature flag */
  accountCount: Scalars['Int']['output'];
  /** Human-readable name of the feature flag */
  displayName: Scalars['String']['output'];
  /** Whether new accounts receive the feature flag automatically */
  enabledByDefault: Scalars['Boolean']['output'];
  /** Machine name of the feature flag */
  feature: Scalars['String']['output'];
};

/** A feature flag available in the catalog (VP staff administration surface) */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /** Human-readable name of the feature flag */
  displayName: Scalars['String']['output'];
  /** Machine name of the feature flag */
  feature: Scalars['String']['output'];
};

/** Represents an order in the system, full details */
export type OrderDetails = {
  __typename?: 'OrderDetails';
  /** The account associated with the order */
  account: AccountSummary;
  /** Store credit applied to the order (null when none) */
  appliedCredit?: Maybe<Scalars['Float']['output']>;
  /** Card brand used for the order (from cc_type); null for non-card payments */
  cardBrand?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency code of the order */
  currency: Scalars['String']['output'];
  /** The customer associated with the order */
  customer?: Maybe<Customer>;
  /** Discount amount applied to the order */
  discountAmount: Scalars['Float']['output'];
  /** Discount code applied to the order */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** Discount ID applied to the order */
  discountId?: Maybe<Scalars['Int']['output']>;
  /** Donation amount applied to the order */
  donation: Scalars['Float']['output'];
  /** The event associated with the order */
  event?: Maybe<EventSummary>;
  /** Unique fingerprint of the order */
  fingerprint: Scalars['String']['output'];
  /** Unique identifier for the order */
  id: Scalars['Int']['output'];
  /** Last four digits of the credit card used for the order */
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  /** List of line items in the order */
  lineItems: Array<LineItem>;
  /** The source of the order */
  origin: OrderOriginEnum;
  /** Payment method used for the order */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** Platform fee charged for the order, in the order currency (see `currency`). Matches the platform fee sent to Stripe. */
  platformFee: Scalars['Float']['output'];
  /** Processing fee charged for the order */
  processingFee: Scalars['Float']['output'];
  /** Timestamp when the order was purchased */
  purchasedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Total amount refunded across all refunds on the order */
  refundedAmount: Scalars['Float']['output'];
  /** Computed refund status of the order (none/partial/full) */
  refundStatus: RefundStatusEnum;
  /** Number of tickets scanned */
  scannedCount: Scalars['Int']['output'];
  /** Current state of the order */
  state: Scalars['String']['output'];
  /** Tax fee charged for the order */
  taxFee: Scalars['Float']['output'];
  /** Total number of tickets purchased */
  ticketCount: Scalars['Int']['output'];
  /** Total amount of the order */
  total: Scalars['Float']['output'];
  /** Transaction ID associated with the order payment */
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Line item in an order */
export type LineItem = {
  __typename?: 'LineItem';
  /** Net amount retained on the line item (discounted price + fee, less refunds) */
  balance: Scalars['Float']['output'];
  /** Whether the line item is claimable */
  claimable: Scalars['Boolean']['output'];
  /** Fee for the line item */
  fee: Scalars['Float']['output'];
  /** Unique identifier for the line item */
  id: Scalars['Int']['output'];
  /** Whether the line item is a ticket or an add-on */
  kind: LineItemKindEnum;
  /** Name of the line item */
  name: Scalars['String']['output'];
  /** Gross amount paid by the customer for the line item (price + fee, before refunds) */
  paid: Scalars['Float']['output'];
  /** URL to the ticket PDF */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Price for the line item */
  price: Scalars['Float']['output'];
  /** Whether the line item has been used */
  scanned: Scalars['Boolean']['output'];
  /** List of scan events for the line item */
  scans: Array<LineItemScan>;
  /** Seat number for the line item */
  seat?: Maybe<Scalars['String']['output']>;
  /** Table number for the line item */
  table?: Maybe<Scalars['String']['output']>;
  /** Identifier of the underlying ticket record */
  ticketId: Scalars['Int']['output'];
  /** Ticket tier/type name (e.g. "GA: Tier 1") */
  tier?: Maybe<Scalars['String']['output']>;
  /** Unique token for the line item */
  token: Scalars['String']['output'];
};

export enum LineItemKindEnum {
  Addon = 'addon',
  Ticket = 'ticket'
}

/** Type representing a ticket scan event */
export type LineItemScan = {
  __typename?: 'LineItemScan';
  /** Date and time when the ticket was scanned */
  scannedAt: Scalars['ISO8601DateTime']['output'];
  /** User who scanned the ticket */
  scannedBy?: Maybe<PublicUser>;
};

/** Public information about a user */
export type PublicUser = {
  __typename?: 'PublicUser';
  /** Email address of the user */
  email: Scalars['String']['output'];
  /** Name of the user */
  name: Scalars['String']['output'];
};

export type OrderSearchArguments = {
  /** Restrict orders to this account. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Read orders across every account (staff cross-account access). This is the explicit way to request an unscoped read; when true it takes precedence over accountId. When false and no accountId is given, the query is rejected rather than silently returning every account. */
  allAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter orders created after this date/time */
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Filter orders created before this date/time */
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** List of Event IDs to filter orders by. */
  eventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter orders by (partial) fingerprint */
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  /** Filter orders by platform */
  origin?: InputMaybe<Array<OrderOriginEnum>>;
  /** Filter orders by payment method */
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** General search query to filter orders */
  q?: InputMaybe<Scalars['String']['input']>;
  /** Filter orders by state */
  state?: InputMaybe<Array<OrderStateEnum>>;
};

export enum OrderStateEnum {
  AwaitingPayment = 'awaiting_payment',
  Completed = 'completed',
  Draft = 'draft'
}

export type Organization = {
  __typename?: 'Organization';
  /** Indicates if this is the user's default account */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier of the account */
  id: Scalars['Int']['output'];
  /** Name of the account */
  name: Scalars['String']['output'];
};

/** A printable ticket layout (superadmin-managed) */
export type TicketLayout = {
  __typename?: 'TicketLayout';
  /** Whether this layout is the default */
  default: Scalars['Boolean']['output'];
  /** FGL layout definition string */
  fglString?: Maybe<Scalars['String']['output']>;
  /** Ticket layout identifier */
  id: Scalars['Int']['output'];
  /** Structured layout definition */
  layout?: Maybe<Scalars['JSON']['output']>;
  /** Human-readable layout name */
  name: Scalars['String']['output'];
};

/** The connection type for TicketLayout. */
export type TicketLayoutConnection = {
  __typename?: 'TicketLayoutConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TicketLayoutEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TicketLayout>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TicketLayoutEdge = {
  __typename?: 'TicketLayoutEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TicketLayout>;
};

/** Type */
export type Type = {
  __typename?: 'Type';
  /** Unique identifier for the type */
  id: Scalars['String']['output'];
  /** Name of the type */
  name: Scalars['String']['output'];
};

/** Criteria for the staff user lookup: an exact id and/or a partial name/email match */
export type UserSearchArguments = {
  /** Exact match on a single user id. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Partial (case-insensitive) match on the user name or email. */
  q?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** A user, with their cross-account memberships (staff lookup view) */
export type User = {
  __typename?: 'User';
  /** Whether the user has ever signed in (a support signal for login issues) */
  active: Scalars['Boolean']['output'];
  /** Email address of the user */
  email: Scalars['String']['output'];
  /** Unique identifier for the user */
  id: Scalars['Int']['output'];
  /** Account memberships (account id/name + role) — enough to jump to the account in the admin UI */
  memberships: Array<UserAccountMembership>;
  /** Name of the user */
  name: Scalars['String']['output'];
};

/** One of a user's account memberships: which account they belong to and their role */
export type UserAccountMembership = {
  __typename?: 'UserAccountMembership';
  /** The account this membership grants access to (id + name to jump to it) */
  account: AccountSummary;
  /** The membership role: 'owner' for the account owner, 'admin' on some memberships, or null when the membership carries only a team role */
  role?: Maybe<Scalars['String']['output']>;
  /** Name of the team role assigned within the account, if any */
  teamRole?: Maybe<Scalars['String']['output']>;
};

/** Filtering options for the staff login-session list */
export type UserSessionFilterArguments = {
  /** Restrict sessions to users who are members of this account. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Read sessions across every account (staff cross-account access). This is the explicit way to request an unscoped read; when true it takes precedence over accountId. When false and no accountId is given, the query is rejected rather than silently returning every account. */
  allAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only sessions created at or after this time. */
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Only sessions created at or before this time. */
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Filter to a single login source (exact match). */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for UserSession. */
export type UserSessionConnection = {
  __typename?: 'UserSessionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserSessionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserSession>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserSessionEdge = {
  __typename?: 'UserSessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserSession>;
};

/** A single staff-visible login session, with whatever device metadata the client supplied */
export type UserSession = {
  __typename?: 'UserSession';
  /** Client app version reported at login, if any */
  appVersion?: Maybe<Scalars['String']['output']>;
  /** When the login occurred */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Device manufacturer reported at login, if any */
  deviceMake?: Maybe<Scalars['String']['output']>;
  /** Device model reported at login, if any */
  deviceModel?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the session */
  id: Scalars['Int']['output'];
  /** IP address the login came from */
  loginIp?: Maybe<Scalars['String']['output']>;
  /** Operating system reported at login, if any */
  osName?: Maybe<Scalars['String']['output']>;
  /** Operating system version reported at login, if any */
  osVersion?: Maybe<Scalars['String']['output']>;
  /** Which login path minted the session (web, box_office, graphql, passkey); 'unknown' for legacy sessions recorded before the source was captured */
  source: Scalars['String']['output'];
  /** Email of the user who logged in */
  userEmail?: Maybe<Scalars['String']['output']>;
};

/** WebhookSubscriptionHistoryEntryCollection type */
export type WebhookSubscriptionHistoryEntryCollection = {
  __typename?: 'WebhookSubscriptionHistoryEntryCollection';
  /** A collection of paginated WebhookSubscriptionHistoryEntryCollection */
  collection: Array<WebhookSubscriptionHistoryEntry>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** A single webhook subscription change from the audit log (VP staff surface) */
export type WebhookSubscriptionHistoryEntry = {
  __typename?: 'WebhookSubscriptionHistoryEntry';
  /** Account that owns (or owned) the subscription */
  accountId: Scalars['Int']['output'];
  /** What happened: add, edit or remove */
  action: Scalars['String']['output'];
  /** Who made the change, including a since-deleted user; null when no actor was recorded */
  actor?: Maybe<WebhookSubscriptionHistoryActor>;
  /** True when VP staff made the change, false for a user of the account; entries recorded before this was stamped use the actor's current staff status */
  actorStaff: Scalars['Boolean']['output'];
  /** Marks an edit that is a secret rotation (secret_rotated), a delivery switch (delivery_switched) or a take-over (ownership_taken); null otherwise */
  change?: Maybe<Scalars['String']['output']>;
  /** When the change was recorded */
  changedAt: Scalars['ISO8601DateTime']['output'];
  /** For a delivery switch, whether delivery was switched on */
  deliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Audited fields that changed, from and to; never includes a signing secret */
  fieldChanges: Array<WebhookSubscriptionHistoryChange>;
  /** Unique identifier for the audit log entry */
  id: Scalars['Int']['output'];
  /** Id of the principal whose access the subscription uses */
  principalId?: Maybe<Scalars['Int']['output']>;
  /** Type of the principal whose access the subscription uses */
  principalType?: Maybe<Scalars['String']['output']>;
  /** The subscription changed; it may since have been deleted */
  subscriptionId: Scalars['Int']['output'];
};

/** The user who changed a webhook subscription -- VP staff, or a user of the owning account */
export type WebhookSubscriptionHistoryActor = {
  __typename?: 'WebhookSubscriptionHistoryActor';
  /** Email address of the user who made the change */
  email: Scalars['String']['output'];
  /** Unique identifier for the user who made the change */
  id: Scalars['Int']['output'];
  /** Name of the user who made the change */
  name?: Maybe<Scalars['String']['output']>;
};

/** One audited webhook subscription field, before and after the change */
export type WebhookSubscriptionHistoryChange = {
  __typename?: 'WebhookSubscriptionHistoryChange';
  /** Name of the subscription field that changed */
  field: Scalars['String']['output'];
  /** Value before the change; null when it was added */
  from?: Maybe<Scalars['JSON']['output']>;
  /** Value after the change; null when it was removed */
  to?: Maybe<Scalars['JSON']['output']>;
};

/** A whitelabel branding configuration for a host domain (VP staff) */
export type WhitelabelConfig = {
  __typename?: 'WhitelabelConfig';
  /** Brand logo attachment */
  attachment?: Maybe<Attachment>;
  /** Attribution line shown on branded checkout and tickets */
  attribution: WhitelabelAttribution;
  /** Base URL used for checkout links */
  checkoutUrlBase?: Maybe<Scalars['String']['output']>;
  /** Host domain the configuration applies to */
  domain: Scalars['String']['output'];
  /** DNS records the client must create, per client-facing host (shared front doors) */
  expectedDnsRecords: Array<WhitelabelExpectedDnsHost>;
  /** From email address for outgoing mail */
  fromEmail?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the whitelabel config */
  id: Scalars['Int']['output'];
  /** Landing URL for the domain */
  landingUrl?: Maybe<Scalars['String']['output']>;
  /** Human-readable brand name */
  name?: Maybe<Scalars['String']['output']>;
  /** Masked Stripe secret API key */
  stripeApiKey?: Maybe<Scalars['String']['output']>;
  /** Stripe publishable key */
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
};

/** The attribution line branded checkout and tickets render for a whitelabel config */
export enum WhitelabelAttribution {
  /** The client's own brand name, linking to their landing URL */
  ClientBrand = 'CLIENT_BRAND',
  /** No attribution line is rendered */
  None = 'NONE',
  /** The default VenuePilot attribution */
  Venuepilot = 'VENUEPILOT'
}

/** The DNS records expected for one client-facing host of a whitelabel config (VP staff) */
export type WhitelabelExpectedDnsHost = {
  __typename?: 'WhitelabelExpectedDnsHost';
  /** Why no records are expected for this host, when records is empty */
  error?: Maybe<Scalars['String']['output']>;
  /** The client-facing host, or null if unresolvable */
  host?: Maybe<Scalars['String']['output']>;
  /** Records the client must create for this host */
  records: Array<WhitelabelExpectedDnsRecord>;
  /** Which host this is: admin or checkout */
  role: Scalars['String']['output'];
};

/** One DNS record a white-label client must create in their zone (VP staff) */
export type WhitelabelExpectedDnsRecord = {
  __typename?: 'WhitelabelExpectedDnsRecord';
  /** Whether the record must be DNS-only (not proxied) */
  dnsOnly: Scalars['Boolean']['output'];
  /** The record name */
  name: Scalars['String']['output'];
  /** Why the record is needed */
  purpose: WhitelabelDnsRecordPurpose;
  /** Which host the record is for: admin or checkout */
  role: Scalars['String']['output'];
  /** The record target */
  target: Scalars['String']['output'];
  /** The DNS record type */
  type: Scalars['String']['output'];
};

/** Why a white-label client must create a DNS record */
export enum WhitelabelDnsRecordPurpose {
  /** Delegates ACME validation to Cloudflare so certificates renew unattended */
  CertificateValidation = 'CERTIFICATE_VALIDATION',
  /** Routes the client host to the shared front door for its surface */
  Traffic = 'TRAFFIC'
}

/** Onboarding status for a whitelabel config from its last stored check, accounts read live (VP staff) */
export type WhitelabelOnboardingStatus = {
  __typename?: 'WhitelabelOnboardingStatus';
  /** Accounts attached to the config, read live */
  accounts: Array<WhitelabelAccountBrandingStatus>;
  /** When the stored onboarding check ran */
  checkedAt: Scalars['ISO8601DateTime']['output'];
  /** Stored Cloudflare custom-hostname status per client-facing host */
  cloudflareHostnames: Array<WhitelabelCloudflareHostnameStatus>;
  /** Identifier of the whitelabel config */
  configId: Scalars['Int']['output'];
  /** Each expected DNS record checked against the client's DNS */
  dnsRecords: Array<WhitelabelDnsRecordCheck>;
  /** The config domain (admin/login host) */
  domain: Scalars['String']['output'];
  /** Overall onboarding state, derived from the stored check and the live accounts */
  state: WhitelabelOnboardingState;
};

/** An account attached to a whitelabel config (VP staff) */
export type WhitelabelAccountBrandingStatus = {
  __typename?: 'WhitelabelAccountBrandingStatus';
  /** Identifier of the attached account */
  accountId: Scalars['Int']['output'];
  /** Name of the attached account */
  name?: Maybe<Scalars['String']['output']>;
};

/** Cloudflare custom-hostname status for one client-facing host (VP staff) */
export type WhitelabelCloudflareHostnameStatus = {
  __typename?: 'WhitelabelCloudflareHostnameStatus';
  /** Cloudflare SSL certificate status, or null if unknown */
  certificateStatus?: Maybe<Scalars['String']['output']>;
  /** False when Cloudflare could not be reached for this host */
  checked: Scalars['Boolean']['output'];
  /** Why the Transform Rule coverage check failed */
  coverageError?: Maybe<Scalars['String']['output']>;
  /** The custom origin server the hostname routes to */
  customOriginServer?: Maybe<Scalars['String']['output']>;
  /** Why the Cloudflare check failed, when checked is false */
  error?: Maybe<Scalars['String']['output']>;
  /** The client-facing host checked, or null if unresolvable */
  host?: Maybe<Scalars['String']['output']>;
  /** Whether a custom hostname exists; null if not checked */
  hostnameRegistered?: Maybe<Scalars['Boolean']['output']>;
  /** Cloudflare hostname status, or null if unknown */
  hostnameStatus?: Maybe<Scalars['String']['output']>;
  /** Which host this is: admin or checkout */
  role: Scalars['String']['output'];
  /** Whether the Transform Rule covers this host */
  transformRuleCovered?: Maybe<Scalars['Boolean']['output']>;
};

/** One expected white-label DNS record checked against the client's DNS (VP staff) */
export type WhitelabelDnsRecordCheck = {
  __typename?: 'WhitelabelDnsRecordCheck';
  /** What the client has instead, when wrong or proxied */
  actual?: Maybe<Scalars['String']['output']>;
  /** Why the lookup failed, when could not check */
  error?: Maybe<Scalars['String']['output']>;
  /** The target the record must point at */
  expectedTarget: Scalars['String']['output'];
  /** The record name */
  name: Scalars['String']['output'];
  /** What the client's DNS holds for the record */
  outcome: WhitelabelDnsCheckOutcome;
  /** Why the record is needed */
  purpose: WhitelabelDnsRecordPurpose;
  /** Which host the record is for: admin or checkout */
  role: Scalars['String']['output'];
  /** The DNS record type */
  type: Scalars['String']['output'];
};

/** What the client's DNS holds for one expected white-label record */
export enum WhitelabelDnsCheckOutcome {
  /** The record points at the expected target */
  Correct = 'CORRECT',
  /** The lookup failed or timed out; see error */
  CouldNotCheck = 'COULD_NOT_CHECK',
  /** DNS definitely has no such record */
  Missing = 'MISSING',
  /** The record is proxied through Cloudflare instead of DNS-only; see actual */
  Proxied = 'PROXIED',
  /** The record points somewhere else; see actual */
  Wrong = 'WRONG'
}

/** Overall onboarding state of a whitelabel config */
export enum WhitelabelOnboardingState {
  /** Cloudflare or a DNS record could not be checked; those layers are unknown */
  CouldNotCheck = 'COULD_NOT_CHECK',
  /** Partially onboarded (e.g. a host still pending or unregistered, or a DNS record not correct) */
  HalfBranded = 'HALF_BRANDED',
  /** Fully onboarded: hostnames, certificates and DNS records correct with an account attached */
  Live = 'LIVE',
  /** No accounts attached and no Cloudflare hostname registered */
  NotSetUp = 'NOT_SET_UP',
  /** Registered, certificate-active and DNS correct, but the checkout host is not covered by the x-vp-cf-secret Transform Rule */
  OriginGateUncovered = 'ORIGIN_GATE_UNCOVERED'
}

/** The root mutation type for the internal (VP staff) schema */
export type Mutation = {
  __typename?: 'Mutation';
  /** Unscan every scanned ticket of a ticket blueprint (VP staff, cross-account) */
  bulkUnscanTickets?: Maybe<BulkUnscanTicketsPayload>;
  /** Create a Soundcheck loan for an account (VP staff, cross-account) */
  createSoundcheckLoan?: Maybe<CreateSoundcheckLoanPayload>;
  /** Delete (archive) an account (VP staff) */
  deleteAccount?: Maybe<DeleteAccountPayload>;
  /** Delete a whitelabel configuration (VP staff) */
  deleteWhitelabelConfig?: Maybe<DeleteWhitelabelConfigPayload>;
  /** Make a ticket unclaimable (VP staff, cross-account) */
  makeTicketUnclaimable?: Maybe<MakeTicketUnclaimablePayload>;
  /** Manually complete an order by Stripe payment intent id (VP staff, cross-account) */
  manuallyCompleteOrder?: Maybe<ManuallyCompleteOrderPayload>;
  /** Re-run and store the onboarding check for one whitelabel config (VP staff) */
  recheckWhitelabelOnboarding?: Maybe<RecheckWhitelabelOnboardingPayload>;
  /** Revoke a ticket buyer's partner access tokens, for one customer application or all (VP staff) */
  revokeBuyerPartnerAccessTokens?: Maybe<RevokeBuyerPartnerAccessTokensPayload>;
  /** Create or update an account (VP staff) */
  saveAccount?: Maybe<SaveAccountPayload>;
  /** Create or update an application config (VP staff) */
  saveAppConfig?: Maybe<SaveAppConfigPayload>;
  /** Create or update a categorisation category (VP staff) */
  saveCategory?: Maybe<SaveCategoryPayload>;
  /** Create or update a categorisation subcategory (VP staff) */
  saveSubcategory?: Maybe<SaveSubcategoryPayload>;
  /** Create or update a ticket layout (VP staff) */
  saveTicketLayout?: Maybe<SaveTicketLayoutPayload>;
  /** Create or update a categorisation type (VP staff) */
  saveType?: Maybe<SaveTypePayload>;
  /** Create or update a whitelabel configuration (VP staff) */
  saveWhitelabelConfig?: Maybe<SaveWhitelabelConfigPayload>;
  /** Toggle account feature flags (VP staff, cross-account) */
  setFeatureFlags?: Maybe<SetAccountFeaturesPayload>;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationBulkUnscanTicketsArgs = {
  input: BulkUnscanTicketsInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationCreateSoundcheckLoanArgs = {
  input: CreateSoundcheckLoanInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationDeleteWhitelabelConfigArgs = {
  input: DeleteWhitelabelConfigInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationMakeTicketUnclaimableArgs = {
  input: MakeTicketUnclaimableInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationManuallyCompleteOrderArgs = {
  input: ManuallyCompleteOrderInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationRecheckWhitelabelOnboardingArgs = {
  input: RecheckWhitelabelOnboardingInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationRevokeBuyerPartnerAccessTokensArgs = {
  input: RevokeBuyerPartnerAccessTokensInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationSaveAccountArgs = {
  input: SaveAccountInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationSaveAppConfigArgs = {
  input: SaveAppConfigInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationSaveCategoryArgs = {
  input: SaveCategoryInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationSaveSubcategoryArgs = {
  input: SaveSubcategoryInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationSaveTicketLayoutArgs = {
  input: SaveTicketLayoutInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationSaveTypeArgs = {
  input: SaveTypeInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationSaveWhitelabelConfigArgs = {
  input: SaveWhitelabelConfigInput;
};


/** The root mutation type for the internal (VP staff) schema */
export type MutationSetFeatureFlagsArgs = {
  input: SetAccountFeaturesInput;
};

/** Autogenerated input type of BulkUnscanTickets */
export type BulkUnscanTicketsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the ticket blueprint whose scanned tickets to unscan */
  ticketBlueprintId: Scalars['Int']['input'];
};

/** Autogenerated return type of BulkUnscanTickets. */
export type BulkUnscanTicketsPayload = {
  __typename?: 'BulkUnscanTicketsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors encountered during the operation */
  errors?: Maybe<Array<VpError>>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type VpError = {
  __typename?: 'VpError';
  /** Full error message */
  message: Scalars['String']['output'];
  /** Path to the field that caused the error, or `base` */
  path?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateSoundcheckLoan */
export type CreateSoundcheckLoanInput = {
  /** Id of the account to create the loan for */
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The loan principal at origination */
  originalPrincipalBalance: Scalars['Float']['input'];
  /** Legacy single-percentage recoupment shape, or null */
  perTicketFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Whether recoupment applies to ticket face value */
  recoupIncludesFaceValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether recoupment applies to the venue fee */
  recoupIncludesVenueFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flat recoupment amount, in cents */
  recoupmentFlatCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** How flat and percentage apply */
  recoupmentGrain?: InputMaybe<RecoupmentGrainEnum>;
  /** Recoupment percentage, in basis points */
  recoupmentPercentageBps?: InputMaybe<Scalars['Int']['input']>;
  /** Settlement destination; defaults to the account */
  settlementStripeAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSoundcheckLoan. */
export type CreateSoundcheckLoanPayload = {
  __typename?: 'CreateSoundcheckLoanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors encountered during the operation */
  errors?: Maybe<Array<VpError>>;
  /** The created loan, when successful */
  loan?: Maybe<Loan>;
};

/** Autogenerated input type of DeleteAccount */
export type DeleteAccountInput = {
  /** Identifier of the account to delete */
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteAccount. */
export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if the account could not be deleted */
  errors?: Maybe<Array<VpError>>;
  /** Whether the account was deleted */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteWhitelabelConfig */
export type DeleteWhitelabelConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the whitelabel config to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteWhitelabelConfig. */
export type DeleteWhitelabelConfigPayload = {
  __typename?: 'DeleteWhitelabelConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if the config could not be deleted */
  errors?: Maybe<Array<VpError>>;
  /** Whether the config was deleted */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of MakeTicketUnclaimable */
export type MakeTicketUnclaimableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the ticket to make unclaimable */
  ticketId: Scalars['Int']['input'];
};

/** Autogenerated return type of MakeTicketUnclaimable. */
export type MakeTicketUnclaimablePayload = {
  __typename?: 'MakeTicketUnclaimablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors encountered during the operation */
  errors?: Maybe<Array<VpError>>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ManuallyCompleteOrder */
export type ManuallyCompleteOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the order to be completed */
  orderId: Scalars['Int']['input'];
  /** Payment Intent ID associated with the payment */
  paymentIntentId: Scalars['String']['input'];
};

/** Autogenerated return type of ManuallyCompleteOrder. */
export type ManuallyCompleteOrderPayload = {
  __typename?: 'ManuallyCompleteOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors encountered during the operation */
  errors?: Maybe<Array<VpError>>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RecheckWhitelabelOnboarding */
export type RecheckWhitelabelOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the whitelabel config to recheck */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RecheckWhitelabelOnboarding. */
export type RecheckWhitelabelOnboardingPayload = {
  __typename?: 'RecheckWhitelabelOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if the config could not be found */
  errors?: Maybe<Array<VpError>>;
  /** The stored onboarding check */
  status?: Maybe<WhitelabelStoredOnboardingStatus>;
};

/** A stored white-label onboarding check: the external layers and when it ran (VP staff) */
export type WhitelabelStoredOnboardingStatus = {
  __typename?: 'WhitelabelStoredOnboardingStatus';
  /** When this onboarding check ran */
  checkedAt: Scalars['ISO8601DateTime']['output'];
  /** Stored Cloudflare custom-hostname status per client-facing host */
  cloudflareHostnames: Array<WhitelabelCloudflareHostnameStatus>;
  /** Identifier of the whitelabel config */
  configId: Scalars['Int']['output'];
  /** Stored check of each expected DNS record against the client's DNS */
  dnsRecords: Array<WhitelabelDnsRecordCheck>;
};

/** Autogenerated input type of RevokeBuyerPartnerAccessTokens */
export type RevokeBuyerPartnerAccessTokensInput = {
  /** Application id of the partner app; omit to revoke the buyer's tokens for every app */
  applicationId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The buyer's email address */
  email: Scalars['String']['input'];
};

/** Autogenerated return type of RevokeBuyerPartnerAccessTokens. */
export type RevokeBuyerPartnerAccessTokensPayload = {
  __typename?: 'RevokeBuyerPartnerAccessTokensPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors, if nothing could be revoked */
  errors?: Maybe<Array<VpError>>;
  /** Number of live tokens revoked; 0 when the buyer had none */
  revokedCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the revocation ran */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveAccount */
export type SaveAccountInput = {
  /** Attributes for the account */
  accountAttributes: AccountAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Account whose team roles are cloned onto a new account */
  sourceAccountId?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes for creating or updating an account */
export type AccountAttributes = {
  /** Box office processor */
  boxOfficeProcessor?: InputMaybe<BoxOfficeProcessorEnum>;
  /** How long a cart holds inventory, in minutes */
  cartLockDuration?: InputMaybe<Scalars['Float']['input']>;
  /** Identifier of the fee structure to apply */
  feeStructureId?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifier for the account (omit to create) */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Identifier of the logo attachment */
  logoId?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the account */
  name: Scalars['String']['input'];
  /** Owner user of the account */
  owner?: InputMaybe<UserAttributes>;
  /** Max recoupable share (basis points) across all stacked advances; null uses the 60% default */
  recoupmentCeilingBps?: InputMaybe<Scalars['Int']['input']>;
  /** Stripe account id for Soundcheck */
  soundcheckStripeAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Max webhook subscriptions the account may hold; null uses the platform default */
  webhookSubscriptionLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Identifier of the whitelabel config */
  whitelabelConfigId?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes for the owner user of an account */
export type UserAttributes = {
  /** Email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the user */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the user */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveAccount. */
export type SaveAccountPayload = {
  __typename?: 'SaveAccountPayload';
  /** The saved account */
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors, if the save failed */
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of SaveAppConfig */
export type SaveAppConfigInput = {
  /** Attributes for the app config */
  appConfig: AppConfigAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for creating or updating an application config */
export type AppConfigAttributes = {
  /** Context the app config targets */
  appContext?: InputMaybe<AppConfigContextEnum>;
  /** Whether requests must match the configured origin */
  enforceOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier for the app config (omit to create) */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Absolute https URL the login email sends buyers to (customer applications). The login token is appended as a `token` query parameter, keeping any other parameters and any fragment and replacing a `token` already there. Required for customer applications. */
  loginUrl?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable name of the app config */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Allowed request origin for the API consumer */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** Requests allowed per window for each API key (or, without one, each user or anonymous IP) on this app; null = unlimited */
  rateLimitMaxRequests?: InputMaybe<Scalars['Int']['input']>;
  /** Length of the rate-limit window in seconds (1 to 3600) */
  rateLimitPeriodSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Base URL for the API consumer */
  urlBase?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveAppConfig. */
export type SaveAppConfigPayload = {
  __typename?: 'SaveAppConfigPayload';
  /** The saved app config */
  appConfig?: Maybe<AppConfig>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors, if the save failed */
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of SaveCategory */
export type SaveCategoryInput = {
  /** Attributes for the category */
  category: CategoryAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryAttributes = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of SaveCategory. */
export type SaveCategoryPayload = {
  __typename?: 'SaveCategoryPayload';
  /** The category that was created or updated */
  category?: Maybe<Category>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors that occurred during category creation or update */
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of SaveSubcategory */
export type SaveSubcategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes for the subcategory */
  subcategory: SubcategoryAttributes;
};

export type SubcategoryAttributes = {
  categoryId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of SaveSubcategory. */
export type SaveSubcategoryPayload = {
  __typename?: 'SaveSubcategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors that occurred during subcategory creation or update */
  errors?: Maybe<Array<VpError>>;
  /** The subcategory that was created or updated */
  subcategory?: Maybe<Subcategory>;
};

/** Autogenerated input type of SaveTicketLayout */
export type SaveTicketLayoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes for the ticket layout */
  ticketLayout: TicketLayoutAttributes;
};

export type TicketLayoutAttributes = {
  /** Whether this layout is the default */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** FGL layout definition string */
  fglString?: InputMaybe<Scalars['String']['input']>;
  /** Ticket layout identifier */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Structured layout definition */
  layout?: InputMaybe<Scalars['JSON']['input']>;
  /** Human-readable layout name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveTicketLayout. */
export type SaveTicketLayoutPayload = {
  __typename?: 'SaveTicketLayoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors that occurred during creation or update */
  errors?: Maybe<Array<VpError>>;
  /** The ticket layout that was created or updated */
  ticketLayout?: Maybe<TicketLayout>;
};

/** Autogenerated input type of SaveType */
export type SaveTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes for the type */
  type: TypeAttributes;
};

export type TypeAttributes = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of SaveType. */
export type SaveTypePayload = {
  __typename?: 'SaveTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors that occurred during type creation or update */
  errors?: Maybe<Array<VpError>>;
  /** The type that was created or updated */
  type?: Maybe<Type>;
};

/** Autogenerated input type of SaveWhitelabelConfig */
export type SaveWhitelabelConfigInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whitelabel config attributes */
  config: WhitelabelAttributes;
};

/** Attributes for creating or updating a whitelabel config */
export type WhitelabelAttributes = {
  /** Attachment id to use as the brand logo */
  attachmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Attribution line shown on branded checkout and tickets */
  attribution?: InputMaybe<WhitelabelAttribution>;
  /** Base URL used for checkout links */
  checkoutUrlBase?: InputMaybe<Scalars['String']['input']>;
  /** Host domain the configuration applies to */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** From email address for outgoing mail */
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  /** Whitelabel configuration identifier (omit to create) */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Landing URL for the domain */
  landingUrl?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable brand name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveWhitelabelConfig. */
export type SaveWhitelabelConfigPayload = {
  __typename?: 'SaveWhitelabelConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The saved whitelabel config */
  config?: Maybe<WhitelabelConfig>;
  /** Validation errors, if the save failed */
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of SetAccountFeatures */
export type SetAccountFeaturesInput = {
  /** The feature flags to enable or disable */
  accountFeatures: Array<AccountFeatureAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AccountFeatureAttributes = {
  /** Account to toggle the feature for; ignored when applyToAll is true. Omit (null) to set or unset the feature as the default for new accounts (the account_id IS NULL row). */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Apply the change to every account instead of a single account */
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to enable (true) or disable (false) the feature */
  enabled: Scalars['Boolean']['input'];
  /** Machine name of the feature flag to toggle */
  feature: Scalars['String']['input'];
};

/** Autogenerated return type of SetAccountFeatures. */
export type SetAccountFeaturesPayload = {
  __typename?: 'SetAccountFeaturesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    